import '../index.css'
import { createRoot } from 'react-dom/client'
import { Application } from './application'
import { redirectToCanonicalHost } from './canonical-host'
import { applyCzechDict } from './dict-cs'

applyCzechDict()

// The admin bundle is deployed to two hosts: the worker host (where /rpc,
// /_api and the SPA are all served same-origin) and Contember Cloud (which
// serves /_api but NOT our custom /rpc route). Anything served from the wrong
// host silently breaks search / delete / duplicate / manual order. Bounce to
// the canonical worker host before booting so there is one working admin URL.
if (!redirectToCanonicalHost()) {
	const rootEl = document.body.appendChild(document.createElement('div'))
	createRoot(rootEl).render(<Application />)
}
